import { Card, PageHeading } from '@aulaviva/ui';
import { useUtenteArea } from '@/layout/LayoutPartecipante';
import { profilo } from '@/testi';
import { ITuoiDati } from './componenti/ITuoiDati';

export function Profilo() {
  const u = useUtenteArea();
  const righe: Array<{ etichetta: string; valore: string; mono?: boolean }> = [
    { etichetta: profilo.nome, valore: u.nome },
    { etichetta: profilo.cognome, valore: u.cognome },
    { etichetta: profilo.email, valore: u.email },
    { etichetta: profilo.codiceFiscale, valore: u.codiceFiscaleMascherato, mono: true },
    { etichetta: profilo.ordine, valore: u.ordine ?? profilo.nonIndicato },
    { etichetta: profilo.numeroAlbo, valore: u.numeroAlbo ?? profilo.nonIndicato },
    { etichetta: profilo.ruolo, valore: profilo.ruoli[u.ruolo] },
  ];
  return (
    <>
      <PageHeading subtitle={profilo.sottotitolo}>{profilo.titolo}</PageHeading>
      <Card>
        <dl className="grid grid-cols-1 sm:grid-cols-[max-content_1fr] gap-x-8 gap-y-4">
          {righe.map((r) => (
            <div key={r.etichetta} className="contents">
              <dt className="t-label text-ink-muted">{r.etichetta}</dt>
              <dd className={r.mono ? 't-code' : 't-body'}>{r.valore}</dd>
            </div>
          ))}
        </dl>
      </Card>
      <ITuoiDati />
    </>
  );
}
